/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface TextValueDto
 */
export interface TextValueDto {
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TextValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    $type?: TextValueDtoTypeEnum;
}


/**
 * @export
 */
export const TextValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersTextValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TextValueDtoTypeEnum = typeof TextValueDtoTypeEnum[keyof typeof TextValueDtoTypeEnum];


/**
 * Check if a given object implements the TextValueDto interface.
 */
export function instanceOfTextValueDto(value?: unknown): value is TextValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TextValueDtoTypeEnum)[0];
}

export function TextValueDtoFromJSON(json: any): TextValueDto {
    return TextValueDtoFromJSONTyped(json, false);
}

export function TextValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'groupHash': !exists(json, 'groupHash') ? undefined : json['groupHash'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TextValueDtoToJSON(value?: TextValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'value': value.value,
        'groupName': value.groupName,
        'groupHash': value.groupHash,
        '$type': value.$type,
    });
}

